<div class="sakai-table-container">
  <p-confirmDialog></p-confirmDialog>
  <p-toast></p-toast>

  <div class="card">
    <div class="flex flex-column lg:flex-row lg:justify-content-between lg:align-items-center gap-3 p-3">
      <div class="p-text-center p-mb-2 lg:mb-0">
        {{ translateServ.dictionary['MAINT_CS_HEADER'] }}
      </div>

      <div class="flex flex-wrap align-items-center gap-2 lg:ml-auto">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            [(ngModel)]="searchValue"
            (input)="onGlobalFilter($event)"
            [placeholder]="translateServ.dictionary['MAINT_CS_ACT_USER_SEARCH']"
            class="p-inputtext-sm"
          />
        </span>
        <button
          pButton
          type="button"
          icon="pi pi-times"
          class="p-button-outlined p-button-sm"
          (click)="clear()"
          pTooltip="{{ translateServ.dictionary['TOOLTIP_CLEAR_FILTER'] }}"
          tooltipPosition="bottom"
        ></button>
      </div>

      <button
        pButton
        icon="pi pi-plus"
        label="{{translateServ.dictionary['CREATE_ACC']}}"
        (click)="openCreateDialog()"
        class="p-button-outlined p-button-sm"
      ></button>
    </div>
    <p-toolbar styleClass="mb-4">
      <ng-template pTemplate="left">
        <button
          pButton
          label="{{ translateServ.dictionary['BTN_REFRESH'] }}"
          icon="pi pi-refresh"
          class="p-button-outlined mr-2"
          (click)="refreshData()"
          pTooltip="{{ translateServ.dictionary['TOOLTIP_REFRESH'] }}"
          tooltipPosition="bottom"
        ></button>
        <button
          pButton
          icon="pi pi-fw {{ isExpanded ? 'pi-minus' : 'pi-plus' }}"
          [label]="isExpanded ? translateServ.dictionary['MAINT_CS_ACT_BTN_COLLAPSE_ALL'] : translateServ.dictionary['MAINT_CS_ACT_BTN_EXPAND_ALL']"
          (click)="expandAll()"
          class="p-button-outlined p-button-sm ml-2"
        ></button>
      </ng-template>

      <ng-template pTemplate="right">
        <label class="font-semibold mr-2">{{ translateServ.dictionary['MAINT_CS_ACT_VIEW'] }}:</label>
        <p-selectButton
          [options]="entityTypeOptions"
          [(ngModel)]="selectedEntityType"
          optionLabel="label"
          optionValue="value"
          (onChange)="onEntityTypeChange()"
          styleClass="p-button-sm"
        ></p-selectButton>
      </ng-template>
    </p-toolbar>

    <p-table
      #dt1
      styleClass="app-data-table app-data-table--paged"
      [value]="users"
      dataKey="id"
      [(selection)]="selectedUsers"
      [expandedRowKeys]="expandedRows"
      [scrollable]="true"
      (onRowExpand)="onRowExpand($event)"
      (onRowCollapse)="onRowCollapse($event)"
      [resizableColumns]="true"
      [reorderableColumns]="true"
      [tableStyle]="{'width': '100%', 'max-width': '100%', 'flex-shrink': '0'}"
      responsiveLayout="scroll"
      [loading]="loading"
      [globalFilterFields]="globalFilterFields"
      [paginator]="true"
			[totalRecords]="users.length"
      [rows]="getCurrentPageSize(0, users.length)"
      [rowsPerPageOptions]="setPaginator(users.length)"
      [showCurrentPageReport]="true"
      (onPage) = "onRowsPerPageChange($event, 0, users.length)"
      currentPageReportTemplate="{{ translateServ.dictionary['TAB_FOOTER_SHOWING'] }} {first} {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} {{ translateServ.dictionary['TAB_FOOTER_ENTRIES'] }}"
    >
    <ng-template let-item pTemplate="paginatordropdownitem">
      {{ item.value === users.length ? 'All' : item.value }}
    </ng-template>
      <ng-template pTemplate="caption">
        <div class="flex flex-wrap justify-content-end align-items-center gap-2 px-2">
            <p-dropdown
              [options]="statusOptions"
              [(ngModel)]="statusFilter"
              optionLabel="label"
              optionValue="value"
              [placeholder]="translateServ.dictionary['FILTER_BY_STATUS_PLACEHOLDER']"
              [showClear]="true"
              (onChange)="dt1.filter($event.value, 'isActive', 'equals')"
              styleClass="p-dropdown-sm"
            ></p-dropdown>

            <button
              pButton
              icon="pi pi-filter-slash"
              [label]="translateServ.dictionary['MAINT_CS_ACT_BTN_CLEAR']"
              (click)="clear()"
              class="p-button-outlined p-button-sm"
            ></button>
        </div>
      </ng-template>


      <ng-template pTemplate="header">
        <tr>
          <th style="width: 4rem; text-align: center;"></th>
          <th *ngFor="let col of cols">
            <ng-container *ngIf="col.visibility">
              {{ col.header }}
              <p-sortIcon [field]="col.field"></p-sortIcon>
              <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter>
            </ng-container>
          </th>
          <th style="width: 8rem">{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS'] }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-user>
        <tr>
          <td>
            <button
              type="button"
              class="p-button p-component p-button-text p-button-sm p-button-rounded"
              [pRowToggler]="user"
              style="width: 2rem; height: 2rem;"
            >
              <i
                class="pi"
                [ngClass]="
                  expandedRows[user.id]
                    ? 'pi-chevron-down'
                    : (dirServ.isRtl() ? 'pi-chevron-left' : 'pi-chevron-right')
                "
                style="font-size: 0.8rem;"
              ></i>
            </button>
          </td>
          <td *ngFor="let col of cols">
            <ng-container *ngIf="col.visibility">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'mainName'">
                  <div class="flex align-items-center gap-2">
                    <i class="pi pi-user text-400" style="font-size: 1.5rem"></i>
                    <span class="font-semibold">{{ user[col.field] }}</span>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'customer_vat_expences_num'">
                  <ng-container *ngIf="user.customer_vat_expences_num === null || user.customer_vat_expences_num === ''">
                    <i class="pi pi-clock text-400" pTooltip="{{translateServ.dictionary['NOT_DEFINED']}}" tooltipPosition="top"></i>
                  </ng-container>
                  <ng-container *ngIf="user.customer_vat_expences_num !== null && user.customer_vat_expences_num !== ''">
                    {{ user.customer_vat_expences_num }}
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'withholdingTaxCode'">
                  <ng-container *ngIf="!user.withholdingTaxCode && !user.withholdingTaxAcc">
                    <i class="pi pi-clock text-400" pTooltip="{{translateServ.dictionary['NOT_DEFINED']}}" tooltipPosition="top"></i>
                  </ng-container>
                  <ng-container *ngIf="user.withholdingTaxCode || user.withholdingTaxAcc">
                    <span [pTooltip]="user.withholdingTaxAcc" tooltipPosition="top" style="line-height:1.1;">
                      {{ user.withholdingTaxCode }}<br />
                      <span style="font-size:0.95em; color: #666;">{{ user.withholdingTaxAcc }}</span>
                    </span>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'isActive'">
                  <p-tag
                    [value]="user.isActive ? translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_ACT'] : translateServ.dictionary['MAINT_CS_ACT_SEL_VIEW_INACT']"
                    [severity]="getSeverity(user.isActive)"
                    [rounded]="true"
                  ></p-tag>
                </ng-container>
                <ng-container *ngSwitchCase="'DateEntered'">
                  {{ user.DateEntered ? (user.DateEntered | date:'mediumDate') : translateServ.dictionary['NOT_AVAILABLE'] }}
                </ng-container>
                <ng-container *ngSwitchCase="'DateUpdated'">
                  {{ user.DateUpdated ? (user.DateUpdated | date:'mediumDate') : translateServ.dictionary['NOT_AVAILABLE'] }}
                </ng-container>
                <ng-container *ngSwitchDefault>
                  {{ user[col.field] }}
                </ng-container>
              </ng-container>
            </ng-container>
          </td>
          <td>
            <div class="flex gap-2">
              <button
                pButton
                icon="pi pi-pencil"
                (click)="editUser(user.id)"
                class="p-button-rounded p-button-text p-button-sm"
                [pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']"
                tooltipPosition="top"
              ></button>
              <button
                pButton
                [icon]="user.isActive ? 'pi pi-times' : 'pi pi-check'"
                (click)="toggleUserStatus(user.id)"
                class="p-button-rounded p-button-text p-button-sm"
                [ngClass]="user.isActive ? 'p-button-danger' : 'p-button-success'"
                [pTooltip]="user.isActive ? translateServ.dictionary['TOOLTIP_DEACTIVATE_USER'] : translateServ.dictionary['TOOLTIP_ACTIVATE_USER']"
                tooltipPosition="top"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template #expandedrow let-user>
        <tr>
          <td [attr.colspan]="cols.length + 2">
            <div class="p-3" style="display: flex; justify-content: center;">
              <p-tabView
                [(activeIndex)]="user.activeTabIndex"
                (onChange)="onTabChange($event, user)"
                [scrollable]="true"
                [style]="{'width': '100%', 'max-width': '100%', 'flex-shrink': '0'}" >

                <p-tabPanel [header]="translateServ.dictionary['MAINT_CS_TAB_ADI_NAMES']" leftIcon="pi pi-tag">
                  <app-tab-additional-name
                    [customerRecId]="user.id"
                    [additionalNames]="user.additionalNames"
                    [additionalNamesLoading]="user.additionalNamesLoading"
                    [additionalNamesError]="user.additionalNamesError"
                  ></app-tab-additional-name>
                </p-tabPanel>
                <p-tabPanel [header]="translateServ.dictionary['MAINT_CS_TAB_PROF']" leftIcon="pi pi-briefcase">
                  <app-tab-profilers
                    [customerRecId]="user.id"
                    [profiles]="user.profiles"
                    [profilesLoading]="user.profilesLoading"
                    [profilesError]="user.profilesError"
                  ></app-tab-profilers>
                </p-tabPanel>
                <p-tabPanel [header]="translateServ.dictionary['MAINT_CS_TAB_EMAILS']" leftIcon="pi pi-at">
                  <app-tab-emails
                    [customerRecId]="user.id"
                    [emails]="user.emails"
                    [emailsLoading]="user.emailsLoading"
                    [emailsError]="user.emailsError">
                  </app-tab-emails>
                </p-tabPanel>
                <p-tabPanel [header]="translateServ.dictionary['MAINT_CS_TAB_ADDR']" leftIcon="pi pi-map-marker">
                  <app-tab-addresses
                    [customerRecId]="user.id"
                    [addresses]="user.addresses"
                    [addressesLoading]="user.addressesLoading"
                    [addressesError]="user.addressesError"
                  ></app-tab-addresses>
                </p-tabPanel>
                <p-tabPanel [header]="translateServ.dictionary['MAINT_CS_TAB_PHONES']" leftIcon="pi pi-phone">
                  <app-tab-phone-numbers
                    [customerRecId]="user.id"
                    [phoneNumbers]="user.phoneNumbers"
                    [phoneNumbersLoading]="user.phoneNumbersLoading"
                    [phoneNumbersError]="user.phoneNumbersError">
                  </app-tab-phone-numbers>
                </p-tabPanel>
                <p-tabPanel [header]="translateServ.dictionary['MAINT_CS_TAB_PAYMENT']" leftIcon="pi pi-credit-card">
                  <app-tab-payment-info
                    [customerRecId]="user.id"
                    [paymentTypes]="user.paymentTypes"
                    [paymentTypesLoading]="user.paymentTypesLoading"
                    [paymentTypesError]="user.paymentTypesError">
                  </app-tab-payment-info>
                </p-tabPanel>
                <p-tabPanel [header]="translateServ.dictionary['MAINT_CS_TAB_REL']" leftIcon="pi pi-share-alt">
                  <app-tab-relations
                    [selectedEntityType] = "selectedEntityType"
                    [customerRecId]="user.id"
                    [relations]="user.relations"
                    [relationsLoading]="user.relationsLoading"
                    [relationsError]="user.relationsError">
                  </app-tab-relations>
                </p-tabPanel>
                <p-tabPanel *ngIf= this.isEntityIsCustomer() [header]="translateServ.dictionary['MAINT_CS_TAB_MOVE_C']" leftIcon="pi pi-hashtag">
                    <app-tab-move-codes
                      [customerRecId]="user.id"
                      [moveCodes]="user.moveCodes"
                      [moveCodesLoading]="user.moveCodesLoading"
                      [moveCodesError]="user.moveCodesError">
                    </app-tab-move-codes>
                  </p-tabPanel>

                  <p-tabPanel *ngIf= this.isEntityIsCustomer() [header]="translateServ.dictionary['MAINT_CS_TAB_MOVE_C6']" leftIcon="pi pi-file-excel">
                    <app-tab-move-code6111
                      [customerRecId]="user.id"
                      [moveCode6111s]="user.moveCode6111s"
                      [moveCode6111sLoading]="user.moveCode6111sLoading"
                      [moveCode6111sError]="user.moveCode6111sError">
                    </app-tab-move-code6111>
                  </p-tabPanel>

                  <p-tabPanel [header]="translateServ.dictionary['MAINT_CS_TAB_URL']" leftIcon="pi pi-link">
                    <app-tab-urls
                      [customerRecId]="user.id"
                      [urls]="user.urls"
                      [urlsLoading]="user.urlsLoading"
                      [urlsError]="user.urlsError">
                    </app-tab-urls>
                  </p-tabPanel>

                  <p-tabPanel *ngIf= this.isEntityIsCustomer() [header]="translateServ.dictionary['MAINT_CS_TAB_UPLOAD']" leftIcon="pi pi-address-book">
                    <app-tab-uploads
                      [uploads]="user.uploads"
                      [uploadsLoading]="user.uploadsLoading"
                      [uploadsError]="user.uploadsError">
                    </app-tab-uploads>
                  </p-tabPanel>
                </p-tabView>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="cols.length + 2" class="text-center p-4">
            <i class="pi pi-users text-400" style="font-size: 3rem"></i>
            <p class="text-500 mt-2">{{translateServ.dictionary['MAINT_NO_USER_FOUND']}}</p>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  header="{{translateServ.dictionary['CREATE_ACC']}}"
  [(visible)]="createAccountDialogVisible"
  [modal]="true"
  [style]="{ width: '60vw' }"
  [closable]="false"
>
  <app-create-account></app-create-account>

  <ng-template pTemplate="footer">
    <button pButton label="Close" icon="pi pi-times" (click)="createAccountDialogVisible = false" class="p-button-text"></button>
    <button pButton label="Open in Full Page" icon="pi pi-external-link" (click)="goToCreateAccountPage()" class="p-button-sm"></button>
  </ng-template>
</p-dialog>